function doAnnouncementBarV2() {
  if (customElements.get("announcement-bar-v2")) return null;

  class AnnouncementBarV2 extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector(".announcementBarV2Slider");
      this.sliderDelayTimer = this.dataset.sliderDelayTimer;
      this.init();
    }
    init() {
      this.executeSwiper();
    }

    executeSwiper() {
      if (this.sliderElement == null) return;
      const delayTimer = this.isStringNumber(this.sliderDelayTimer) ?? 5;
      const delay = delayTimer * 1000;
      const swiper = new Swiper(this.sliderElement, {
        direction: "horizontal",
        loop: false,
        autoHeight: false,
        slidesPerView: 1,
        autoplay: {
          delay,
        },
      });
    }

    isStringNumber(str) {
      if (!str) return false;
      const number = parseFloat(str);
      return !isNaN(number) ? number : false;
    }
  }
  customElements.define("announcement-bar-v2", AnnouncementBarV2);
}
doAnnouncementBarV2();
